import request from '@/CommonDP/utils/request';
export default {
  //内部人员导出
  exportExcelUrl(enterpriseId,isEnabled,keyword) {
    return process.env.VUE_APP_API+`/insiders/export?enterpriseId=${enterpriseId}&isEnabled=${isEnabled}&keyword=${keyword}`
  }
}
